<div *ngIf="controlDir" class="pl-checkbox flex flex-col bg-pl-gray-250">
  <div class="flex justify-between gap-4 p-5">
    <div class="flex min-w-0 flex-1 flex-col gap-4">
      <h4 class="whitespace-normal break-words text-pl-gray-450">{{ label | plSlice: 300 }}</h4>
      <p *ngIf="selectMessage" [class.text-pl-error]="controlDir.dirty && controlDir.invalid && isFormSubmitted">
        {{ selectMessage }}
      </p>
    </div>

    <pl-icon-custom-control
      [isDirty]="!!controlDir.dirty"
      [isValid]="!!controlDir.valid"
      [isFocused]="false"
      [isDisabled]="isDisabled"
      [isFormSubmitted]="isFormSubmitted"
    />
  </div>

  <ng-container *ngFor="let item of items | slice: 0 : minItemsDisplayed; let isLast = last">
    <pl-radio-item
      #radioItems
      [item]="item"
      [name]="identifier"
      [(ngModel)]="radioValue"
      (ngModelChange)="onRadioItemToggle($event)"
      [isLast]="isLast"
      [isDisabled]="isDisabled"
    />
  </ng-container>
  <mat-expansion-panel [(expanded)]="isPanelOpen" class="rounded-0 !shadow-none">
    <ng-container
      *ngFor="let item of items | slice: minItemsDisplayed; let isFirst = first; let isLast = last"
      class="border-white"
      [class.border-t]="!isFirst || minItemsDisplayed === 0"
      [class.border-b]="isLast"
    >
      <pl-radio-item
        [item]="item"
        [name]="identifier"
        [(ngModel)]="radioValue"
        (ngModelChange)="onRadioItemToggle($event)"
        [isLast]="isLast"
        [isDisabled]="isDisabled"
      />
    </ng-container>
  </mat-expansion-panel>

  <div class="w-full px-5 py-2" *ngIf="items.length > minItemsDisplayed && !isPanelOpen">
    <pl-button
      tabindex="1"
      class="!w-fit"
      [variant]="ButtonVariant.white"
      [padding]="ButtonPadding.small"
      (click)="toggleExpansionPanel()"
    >
      <pl-icon [name]="PlIcon.chevron_forward" class="h-8 w-8 rotate-90"></pl-icon>
      <span>{{ 'blocks.ul.show_more' | translate }}</span>
    </pl-button>
  </div>
</div>
